import { useIsPhone } from "../hooks/useIsPhone";
import CareerNetworkArt from "../components/svg/CareerNetworkArt";

export default function CareerScreen() {
  const isPhone = useIsPhone();
  return (
    <section id="why-to-join" className="reveal career-section section-career">
      <div className="career-wrap">
        <div className="content" style={{ maxWidth: 940 }}>
          <h2>Your career</h2>
          <div className="career-grid">
            <div className="career-card">
              <h3>Who we are looking for</h3>
              <p>
                People with exceptional analytical depth, engineering
                discipline, and curiosity. You care about measurable outcomes,
                not slides or hype.
              </p>
            </div>
            <div className="career-card">
              <h3>What you should bring</h3>
              <p>
                Strength in quantitative reasoning, AI/ML or software
                engineering, and an ability to translate complex decisions into
                deployable systems.
              </p>
            </div>
            <div className="career-card">
              <h3>How we work</h3>
              <p>
                Small high-talent teams, direct ownership, and close
                collaboration with enterprise stakeholders from strategy to
                execution.
              </p>
            </div>
            <div className="career-card">
              <h3>Why join now</h3>
              <p>
                You will work on production decision systems used by major
                global organizations and help define the next stage of our
                company.
              </p>
            </div>
          </div>
        </div>
        {!isPhone && <CareerNetworkArt />}
      </div>
    </section>
  );
}
